// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4403":"5c0bf1bae0bc0581","6400":"e3f918fc1af7f5e2"}[chunkId] + ".css";
};